import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { UserService } from '../services/user.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthGuard  {
  
  constructor(private userService:UserService, private router: Router,private authService:OAuthService){

  }

  canActivate(): boolean  {
    // console.log("AUTH Service " +this.authService.instance.getActiveAccount()?.idTokenClaims['oid'])

    let userName = this.userService.getUserFromMsal()
    console.log("USERNAME "+userName)
    if(userName){
      this.userService.setLoggedOn(true)
      return true
    }
    if(! this.userService.isLoggedIn()){
      this.router.navigate(['login']);
      return false
    }
    return true;
  }
  
}